import { Menu } from '@core';

export const MenuDef: Menu[] = [
  // {
  //   route: 'dashboard',
  //   name: 'dashboard',
  //   type: 'link',
  //   icon: 'dashboard',
  // },
  {
    route: 'admin/inventory-area/list',
    name: 'admin.inventory-area.list',
    type: 'link',
    icon: 'list',
    permissions: {
      only: [
        'ROLE_ADMIN'
      ]
    }
  },
  {
    route: 'import/list',
    name: 'imports',
    type: 'link',
    icon: 'cloud_upload',
    permissions: {
      only: [
        'ROLE_IMPORT',
        'ROLE_ADMIN'
      ]
    }
  },
  {
    route: 'export/list',
    name: 'exports',
    type: 'link',
    icon: 'cloud_download',
    permissions: {
      only: [
        'ROLE_EXPORT',
        'ROLE_ADMIN'
      ]
    }
  },
  {
    route: 'app/current',
    name: 'app',
    type: 'link',
    icon: 'smartphone',
  },
  {
    route: 'admin/user/list',
    name: 'admin.user.list',
    type: 'link',
    icon: 'settings',
    // children: [
    //   {
    //     route: 'user/list',
    //     name: 'user.list',
    //     type: 'link'
    //   }
    // ],
    permissions: {
      only: [
        'ROLE_ADMIN'
      ]
    }
  },
  {
    route: 'acceptance-report',
    name: 'acceptance_report',
    type: 'link',
    icon: 'description',
    permissions: {
      only: [
        'ROLE_ADMIN',
        'ROLE_EXPORT'
      ]
    }
  },
  {
    route: 'stoerungsflaechen-export',
    name: 'stoerungsflaechen_export',
    type: 'link',
    icon: 'description',
    permissions: {
      only: [
        'ROLE_ADMIN'
      ]
    }
  },
  {
    route: 'habitat-export',
    name: 'habitat_export',
    type: 'link',
    icon: 'description',
    permissions: {
      only: [
        'ROLE_ADMIN'
      ]
    }
  }
]
